import { render, staticRenderFns } from "./bulma_approval.vue?vue&type=template&id=0fde642d&lang=html"
import script from "./bulma_approval.vue?vue&type=script&lang=js"
export * from "./bulma_approval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports